var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ion:location"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1171275579"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7888 10.4487C11.2622 10.4487 11.646 10.065 11.646 9.59155C11.646 9.11815 11.2622 8.73438 10.7888 8.73438C10.3154 8.73438 9.93164 9.11815 9.93164 9.59155C9.93164 10.065 10.3154 10.4487 10.7888 10.4487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.7898 5.30469C8.42666 5.30469 6.50391 7.1436 6.50391 9.40305C6.50391 10.4791 6.99437 11.91 7.96164 13.6562C8.73845 15.0583 9.63715 16.3261 10.1046 16.9569C10.1836 17.0647 10.2868 17.1524 10.406 17.2128C10.5252 17.2732 10.657 17.3047 10.7906 17.3047C10.9242 17.3047 11.056 17.2732 11.1751 17.2128C11.2943 17.1524 11.3976 17.0647 11.4766 16.9569C11.9432 16.3261 12.8427 15.0583 13.6195 13.6562C14.5852 11.9106 15.0757 10.4796 15.0757 9.40305C15.0757 7.1436 13.1529 5.30469 10.7898 5.30469ZM10.7898 11.3049C10.4507 11.3049 10.1193 11.2044 9.83734 11.016C9.55542 10.8276 9.33568 10.5599 9.20593 10.2466C9.07617 9.93336 9.04222 9.58866 9.10837 9.25611C9.17452 8.92356 9.3378 8.61809 9.57755 8.37833C9.81731 8.13858 10.1228 7.9753 10.4553 7.90915C10.7879 7.843 11.1326 7.87695 11.4458 8.00671C11.7591 8.13646 12.0268 8.3562 12.2152 8.63812C12.4036 8.92004 12.5041 9.2515 12.5041 9.59056C12.5036 10.0451 12.3229 10.4808 12.0015 10.8022C11.6801 11.1236 11.2443 11.3044 10.7898 11.3049Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.297890ca1ec95bbb08ac44863d7eac31.svg";
export { ForwardRef as ReactComponent };